import { Locale } from 'enums/locale';
import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { localizationService } from 'services/LocalizationService';

export const useTranslatedNavigation = () => {
  const { locale, push } = useRouter();

  const translateAndNavigate = useCallback(
    (href: string) => {
      const as = localizationService.translatePathname(href, locale as Locale);
      const pathname = as ?? href;
      push(pathname, as, { locale });
    },
    [locale, push]
  );

  return {
    translateAndNavigate,
  };
};
